// extracted by mini-css-extract-plugin
module.exports = {"movies":"AvailableMovies_movies__2vP_G","movies-appear":"AvailableMovies_movies-appear__3eRWN","error":"AvailableMovies_error__b9srz"};